module.exports = __webpack_public_path__ + "static/img/xykjdyyy.9dc5057.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/participationCenter/xykjdyyy.png
// module id = rOmX
// module chunks = 0